import { FileCopyOutlined } from '@material-ui/icons'
import { bomItemMaterialSummarySelector } from 'features/BillOfMaterials/store/selectors/bomItemMaterialSummarySelector'
import { isEqual } from 'lodash'
import { useAppSelector } from 'store/configureStore'
import { MaterialActions } from 'store/MaterialSelector/MaterialActions'
import { BomItemMenuItem } from './BomItemMenuItem'

export const CopyMaterialMenuItem = ({
  bomItemId,
  onClose,
}: {
  bomItemId: string
  onClose: () => void
}) => {
  const bomItemMaterialSummary = useAppSelector(
    bomItemMaterialSummarySelector(bomItemId),
    isEqual
  )

  return (
    <BomItemMenuItem
      disableIfNotEditable
      action={MaterialActions.copyMaterial}
      actionParams={bomItemMaterialSummary}
      icon={<FileCopyOutlined />}
      primaryTextTranslationKey="project:copy-material"
      secondaryTextTranslationKey="project:copy-material-description"
      closeOnClick
      onClose={onClose}
    />
  )
}
